import type { Resource } from '../../';
export const country_countries_CL: Resource = {"default":"Chile"};
